import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CreditcardFormModel } from './form-credit-card.model'

@Component({
  selector: 'unh-form-credit-card',
  templateUrl: './form-credit-card.component.html',
  styleUrls: ['./form-credit-card.component.scss']
})
export class FormCreditCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();
  @Output() partialData = new EventEmitter();
  @Input() btn_text;
  @Input() isSubmitting;

  creditcardData: CreditcardFormModel;

  @ViewChild('f') form: NgForm;

  ngOnInit() {
    // this.updateFormModel();
    this.creditcardData = new CreditcardFormModel();
  }

  updateFormModel(clear = false) {

  }

  onSubmitPayment() {

  }

  resetForm() {
    if (!this.form.valid) {
      this.updateFormModel(true);
    }
  }

}


